<!-- 日用量报表 -->
<template>
  <div>
    <div class="table-fixed">
      <a-table ref="table" size="middle" :scroll="{x: 'max-content'}" bordered rowKey="id" :columns="columns"
        :dataSource="dataSource" :pagination="ipagination" :loading="loading" class="j-table-force-nowrap"
        :components="drag(columns)" @change="handleTableChange">
      </a-table>
    </div>
  </div>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import {
    mixinDevice
  } from '@/utils/mixin'
  import {
    JeecgListMixin
  } from '@/mixins/JeecgListMixin'
  import {
    AreaChoosetMixin
  } from '@/mixins/AreaChooseMixin'
  import configService from '@/utils/service/config.service'
  import {
    getAction,
    httpAction
  } from '@/api/manage'
  import moment from 'moment'
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil'
  import Vue from 'vue'
  import TableDragResize from '@/mixins/TableDragResize'
  export default {
    name: 'DailyUsageReport',
    mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin, TableDragResize],
    components: {},
    props:{
      id:{
        type: String,
        default: ''
      }
    },
    data() {
      return {
        description: 'DailyUsageReport管理页面',
        collapsed: false,
        url: {
          list: "/jeecg-charge/meter/meterUserWaterReportDay/list",
        },
        beginDate: null,
        endDate: null,
        endOpen: false,
        date: [],
      }
    },
    watch:{
      id(val){
        if(val){
          this.loadData();
        }
      }
    },
    created() {},
    // i18n：表头使用 computed 以响应语言切换
    computed: {
      columns() {
        return [{
            title: this.$t('用户编号'),
            align: "center",
            dataIndex: 'userId'
          }, {
            title: this.$t('表编号'),
            align: "center",
            dataIndex: 'meterId'
          }, {
            title: this.$t('用户姓名'),
            align: "center",
            dataIndex: 'userName'
          }, {
            title: this.$t('用户电话'),
            align: "center",
            dataIndex: 'userPhone'
          }, {
            title: this.$t('用户地址'),
            align: "center",
            dataIndex: 'userAddr',
            customRender: (t, r, index) => {
              if (r.userAreaName) {
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i + 1, r.userAreaName.length) + '-' + t;
              } else {
                return t
              }
            },
          }, {
            title: this.$t('日用量(m³)'),
            align: "center",
            dataIndex: 'dayUse'
          },
          {
            title: this.$t('报表日期'),
            align: "center",
            dataIndex: 'reportDate'
          }
        ]
      }
    },
    methods: {
      loadData(){
        var params = this.getQueryParams();//查询条件
        params.userId = this.id;
        getAction(this.url.list,params).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>